import { list, mount, type List, type RedomComponent, el } from "redom"
import { type RecordItem, RecordItemWithImage } from "./record-item";
import type { RecordsWithUser, RecordsSectionCtx } from "#/types";

export default class RecordTable implements RedomComponent {
    list: List;
    el = el("record-table")
    constructor(recordItemType: Constructor<RecordItem> = RecordItemWithImage) {
        this.list = list("div", recordItemType)
        mount(this, this.list)
    }
    init(data: RecordsWithUser[], context: RecordsSectionCtx) {
        this.list.update(data, context)
    }
}